import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = L.divIcon({ className: "", html: '<div class="pagan-marker promoted"></div>', iconSize: [22, 22], iconAnchor: [11, 22] });

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => { map.setView([lat, lng], map.getZoom()); }, [lat, lng, map]);
  return null;
}

function ClickHandler({ onPick }) {
  useMapEvents({ click(e) { onPick(e.latlng.lat, e.latlng.lng); } });
  return null;
}

export const LocationPicker = ({ lat, lng, onPick }) => {
  return (
    <div className="rounded-lg overflow-hidden border border-[#272A34]" style={{ height: "260px" }} data-testid="location-picker">
      <MapContainer center={[lat, lng]} zoom={11} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer className="dark-tiles" url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        <Recenter lat={lat} lng={lng} />
        <ClickHandler onPick={onPick} />
        <Marker
          position={[lat, lng]}
          icon={pin}
          draggable
          eventHandlers={{ dragend: (e) => { const p = e.target.getLatLng(); onPick(p.lat, p.lng); } }}
        />
      </MapContainer>
    </div>
  );
};

export default LocationPicker;
